module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "hres8ax-deduction"
    }
  }, [_c('div', {
    staticClass: "box-tab2"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('hres8ax-deduction-tab1', {
    attrs: {
      "labels": _vm.labels,
      "detailDeduction": _vm.detailDeduction.table1,
      "detailDeductionTable1": _vm.detailDeductionTable1
    }
  }), _vm._v(" "), _c('hres8ax-deduction-tab2', {
    attrs: {
      "labels": _vm.labels,
      "detailDeduction": _vm.detailDeduction.table2,
      "detailDeductionTable2": _vm.detailDeductionTable2
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53e5fde6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres8ax/deduction.vue
// module id = 3763
// module chunks = 1